import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";
import { updates, updatesExt } from "querypieces";

const query = gql`
  query($limit: Int, $offset: Int) {
    news: entries(
      section: "updates"
      limit: $limit
      offset: $offset
      orderBy: "postDate DESC"
    ) {
      ${updates}
      ${updatesExt}
    }
  }
`;

export default ({ limit }) => {
  return useQuery(query, {
    variables: { limit, offset: 0 },
    notifyOnNetworkStatusChange: true,
    errorPolicy: "all",
  });
};
